// extracted by mini-css-extract-plugin
export var copyContainer = "style-module--copyContainer--0586a";
export var media = "style-module--media--6b0a5";
export var mediaContainer = "style-module--mediaContainer--db570";
export var subline = "style-module--subline--d3f54";
export var title = "style-module--title--97ecf";